import { render, staticRenderFns } from "./sso-callback.vue?vue&type=template&id=6b94c4a0&"
import script from "./sso-callback.vue?vue&type=script&lang=js&"
export * from "./sso-callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports